import { useEffect, useRef } from "react";

import { Box, Group, Menu, Text, TextInput } from "@mantine/core";

export const NumberPropertyField = (props: {
  value: string;
  defaultValue: string;
  hasValue: boolean;
  unit: string;
  units: string[];
  onChange: (value: string | null) => void;
  onEnter?: () => void;
}) => {
  const { value, defaultValue, hasValue, unit, units, onChange } = props;
  const ref = useRef<HTMLInputElement>(null);

  const valueAsString = hasValue ? value : "";

  useEffect(() => {
    if (ref.current == null) return;
    const inputValue = ref.current.value;

    if (inputValue !== valueAsString) {
      ref.current.value = valueAsString;
    }
  }, [value]);

  const unitMenu =
    unit === "" ? null : (
      <Menu shadow="md" width={64} position="bottom-end">
        <Menu.Target>
          <Box
            sx={{
              border: "1px solid transparent",
              borderRadius: 6,
              padding: "0 8px",
              background: "var(--mantine-color-gray-3)",
              flexShrink: 0,
              cursor: "pointer",
            }}
          >
            <Text size={"xs"} c={"dimmed"}>
              {unit}
            </Text>
          </Box>
        </Menu.Target>

        <Menu.Dropdown>
          {units.map((option) => (
            <Menu.Item
              key={option}
              onClick={() => {
                onChange(value + option);
              }}
              ta={"center"}
            >
              {option}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    );

  return (
    <Group>
      <TextInput
        ref={ref}
        placeholder={defaultValue}
        defaultValue={valueAsString}
        // onChange={(event) => {
        //   // onChange(event.currentTarget.value);
        // }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            console.log("Enter key pressed", event);
            onChange(event.currentTarget.value);
            // onChange(event.target.value);
          }
          // onEnter && event.key === "Enter" && onEnter();
        }}
        size="xs"
        variant="filled"
        style={{
          flexGrow: 1,
        }}
        styles={{
          input: {
            padding: "0 8px",
            height: "40px",
            margin: 0,
          },
          rightSection: {
            paddingRight: 8,
          },
        }}
        rightSectionWidth={"auto"}
        rightSectionProps={{
          sx: {
            px: 0,
          },
        }}
        rightSection={unitMenu}
      />
    </Group>
  );
};
